import logo from './logo.svg';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import SignUpPage from './pages/SignUpPage';
import TermsOfServicePage from './pages/terms_of_service_page';
import PrivacyPolicyPage from './pages/privacy_policy_page';
import './App.css';

function App() {
  return (
    <div className="App">
    {/*<h1>
        Hello World
      </h1>
      <p>Element to center as well</p>*/}
     { <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          {/*<Route path="/signup" element={<SignUpPage />} />*/}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/termsofservice" element={<TermsOfServicePage />} />
          <Route path="/privacypolicy" element={<PrivacyPolicyPage />} />
        </Routes>
      </Router>}
    </div>
  );
}

export default App;
